import { IReduxAction, actionGenerator } from '../../../common/utils/actions';

import { EMicrofrontendHostName } from '../../types/reducers/microfrontend';

export const SET_MICROFRONTEND_HOST_NAME = 'SET :: MICROFRONTEND :: HOST_NAME';

export type TSetMicrofrontendHostNameAction = IReduxAction<
  typeof SET_MICROFRONTEND_HOST_NAME,
  EMicrofrontendHostName | null
>;

export const setMicrofrontendHostName = actionGenerator<
  typeof SET_MICROFRONTEND_HOST_NAME,
  EMicrofrontendHostName | null
>(SET_MICROFRONTEND_HOST_NAME);
